export default __webpack_public_path__ + "static/media/search.0315f6be.svg";